import type { RouteRecordRaw } from 'vue-router';
import { isProfileDisabled } from '../guards';

const HomePage = () => import('@/views/company/CompanyPage.vue');
const DashboardPage = () => import('@/views/company/dashboard/DashboardPage.vue');
const CampaignsPage = () => import('@/views/company/campaigns/CampaignsPage.vue');
const ReportsPage = () => import('@/views/company/reports/ReportsPage.vue');
const CampaignBrief = () => import('@/views/company/campaign-brief/CampaignBriefPage.vue');
const BriefDetails = () => import('@/views/company/campaign-brief/components/BriefDetails.vue');
const CreateBrief = () => import('@/views/company/campaign-brief/components/CreateBrief.vue');
const ContractsPage = () => import('@/views/company/contracts/ContractsPage.vue');
const ContractDetailsPage = () => import('@/views/company/contracts/ContractDetailsPage.vue');
const GroupsPage = () => import('@/views/company/groups/GroupsPage.vue');
const CreateGroupPage = () => import('@/views/company/groups/CreateGroupPage.vue');
const GroupDetailsPage = () => import('@/views/company/groups/GroupDetailsPage.vue');
const UniverseGroupDetails = () => import('@/views/company/groups/UniverseGroupDetails.vue');
const JobsPage = () => import('@/views/company/jobs/JobsPage.vue');
const JobDetailsPage = () => import('@/views/jobs/details/JobDetailsPage.vue');
const CreateJobPage = () => import('@/views/jobs/create/CreateJobPage.vue');
const BidPage = () => import('@/views/jobs/bids/BidPage.vue');
const PreApprovalContentsPage = () => import('@/views/company/pre-approval/PreApprovalContentsPage.vue');
const ContentPreApprovalPage = () => import('@/views/pre-approval/ContentPreApprovalPage.vue');
const CompanyPaymentsPage = () => import('@/views/company/payments/PaymentsPage.vue');
const NotificationsPage = () => import('@/views/company/notifications/NotificationsPage.vue');
const CompanySettingsPage = () => import('@/views/company/settings/CompanySettingsPage.vue');
const NewDiscoveryPage = () => import('@/views/company/creator-discovery/NewDiscoveryPage.vue');
const SurveyDetails = () => import('@/views/company/insights/SurveyDetails.vue');
const CompaniesPage = () => import('@/views/company/companies/CompaniesPage.vue');
const Dashboard = () => import('@/views/dashboard/Dashboard.vue');
const ManageTeam = () => import('@/views/manageTeam/ManageTeam.vue');

const InsightDashboardVue = () => import('@/views/company/insights/InsightDashboard.vue');
const Survey = () => import('@/views/company/insights/SurveyDetails.vue');

export const companyRoutes: RouteRecordRaw[] = [
  {
    path: '/companies',
    name: 'companies',
    beforeEnter: isProfileDisabled,
    component: CompaniesPage,
  },
  {
    path: '/dashboard-main',
    name: 'dashboardMain',
    beforeEnter: isProfileDisabled,
    component: Dashboard,
  },
  {
    path: '/manage-team',
    name: 'manage-team',
    beforeEnter: isProfileDisabled,
    component: ManageTeam,
  },
  {
    path: '/companies/:company_id',
    name: 'Company',
    beforeEnter: isProfileDisabled,
    meta: { requireOwnership: true },
    component: HomePage,
    children: [
      {
        path: '',
        name: 'dashboard-redirect',
        redirect: { name: 'dashboard' },
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: DashboardPage,
      },
      {
        path: 'campaigns',
        name: 'campaigns',
        component: CampaignsPage,
      },
      {
        path: 'reports',
        name: 'reports',
        component: ReportsPage,
      },
      {
        path: 'campaign-briefs',
        name: 'campaign-briefs',
        component: CampaignBrief,
      },
      {
        path: 'campaign-briefs/:brief_id',
        name: 'campaign-brief-detail',
        component: BriefDetails,
      },
      {
        path: 'campaign-briefs/create',
        name: 'create-campaign-brief',
        component: CreateBrief,
      },
      {
        path: 'contracts',
        name: 'contracts',
        component: ContractsPage,
      },
      {
        path: 'groups',
        name: 'groups',
        component: GroupsPage,
      },
      {
        path: 'jobs',
        name: 'jobs',
        component: JobsPage,
      },
      {
        path: 'jobs/:job_id',
        name: 'job-details',
        component: JobDetailsPage,
      },
      {
        path: 'start-job',
        name: 'start-job',
        component: CreateJobPage,
      },
      {
        path: 'job/:job_id/bids/:bid_id',
        name: 'bid',
        component: BidPage,
      },
      {
        path: 'pre-approval',
        name: 'pre-approval-contents',
        component: PreApprovalContentsPage,
      },
      {
        path: 'payments',
        name: 'payments',
        component: CompanyPaymentsPage,
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: NotificationsPage,
      },
      {
        path: 'settings',
        name: 'settings',
        component: CompanySettingsPage,
      },
      {
        path: '/companies/:company_id/create-group',
        name: 'create-group',
        meta: { requireOwnership: true },
        component: CreateGroupPage,
      },
      {
        path: '/companies/:company_id/group-details/:group_id',
        name: 'group-details',
        meta: { requireOwnership: true },
        component: GroupDetailsPage,
      },
      {
        path: 'universe-group',
        name: 'universe-group',
        meta: { requireOwnership: true },
        component: UniverseGroupDetails,
      },
      {
        path: 'insights',
        name: 'insights',
        component: InsightDashboardVue,
      },
      {
        path: 'survey/:survey_id',
        name: 'survey',
        component: Survey,
      },
    ],
  },
  {
    path: '/companies/:company_id/creator-discovery',
    name: 'discovery-dashboard',
    meta: { requireOwnership: true },
    component: NewDiscoveryPage,
  },
  // ---- //* Insights ---------------------------------------------------------
  {
    path: '/companies/:company_id/survey-details/:survey_id',
    name: 'survey-details',
    component: SurveyDetails,
  },
  // ---- //* Insights End---------------------------------------------------------
  {
    path: '/companies/:company_id/pre-approval/:task_id',
    name: 'content-pre-approval',
    meta: { requireOwnership: true },
    component: ContentPreApprovalPage,
  },
  {
    path: '/companies/:company_id/contracts/:contract_id/campaigns/:campaign_id',
    name: 'contract-details-page',
    meta: { requireOwnership: true },
    component: ContractDetailsPage,
  },
];
